import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllSalesTypesEndpoint } from "~/modules/client/api/salesType/salesTypeApiEndpoints.ts";
import type { SalesType } from "~/modules/client/api/salesType/salesTypesTypes.ts";

export const getAllSalesTypes = (): AxiosApiResponsePromise<SalesType[]> => axiosApi.get(getAllSalesTypesEndpoint);
